import React from 'react'

import './Arrow.css'

export default function Arrow() {
    return (
        <div className="arrow">
                <span></span>
                <span></span>
                <span></span>
        </div>
    )
}
